/* eslint-disable*/
/*
------------------------------------------------
  Check for Quizzes, Mock exams and Questions
------------------------------------------------
*/
var checkCfa1Subscription = function checkCfa1Subscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam,
  examPlanData,
) {
  var flag = false;
  // `examPlanData` is no longer consulted. It was `resp_exam.examPlan[0]` — an
  // ARBITRARY plan, since that query has no ORDER BY, so it is effectively the
  // user's lowest owned plan id. A user owning a mock package (65/66) plus a
  // real one was denied whenever the mock sorted first. Mock entitlements are
  // now excluded per level below, which is both correct and order-independent.
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam)
  ) {
    if (selectedLevel === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            // Mock packages grant ONLY mock exams — never quizzes, questions,
            // notes or videos. See subscription-dataflow.md § "Mock packages".
            if (exam_data[i].levels[j].package_category === 'mock') continue;
            if (exam_data[i].levels[j].isActive) {
              flag = true;
              break;
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        // console.log("worjjjjjjj");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            (exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 19 ||
              exam_data[i].levels[j].package_id === 39 ||
              exam_data[i].levels[j].package_id === 20)
          ) {
            // console.log("work");

            flag = true;
            break;
          }
        }
      }
    }
    return flag;
  }
};
/*
---------------------------
   Check for Notes 
---------------------------
*/
var checkCfa1NotesSubscription = function checkCfa1NotesSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam)
  ) {
    if (selectedLevel === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (exam_data[i].levels[j].partner) {
              /*
              -----------------------
                 for partner users
              -----------------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive &&
                exam_data[i].levels[j].noteStatus !== false
              ) {
                flag = true;
                break;
              } else if (
                // #261 — mirror non-partner: pkg 16 is L1's matching-exam unlimited.
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 16
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            } else {
              /*
              ------------------
                 for app users
              ------------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive &&
                exam_data[i].levels[j].noteStatus !== false
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 16
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            }
          }
        } else {
          flag = true; //for old user
        }
        break;
      } else {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            (exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 19 ||
              exam_data[i].levels[j].package_id === 39 ||
              exam_data[i].levels[j].package_id === 20)
          ) {
            flag = true;
            break;
          }
        }
      }
    }
    return flag;
  }
};

/*
------------------------
  Check for videos
-----------------------
*/
var checkCfa1VideosSubscription = function checkCfa1VideosSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam)
  ) {
    if (selectedLevel === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (exam_data[i].levels[j].partner) {
              /*
              -----------------
                For Partner
              -----------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive &&
                exam_data[i].levels[j].videoStatus !== false
              ) {
                flag = true;
                break;
              } else if (
                // #261 — mirror non-partner: pkg 16 is L1's matching-exam unlimited.
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 16
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            } else {
              /*
              -------------
                For App
              -------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive &&
                exam_data[i].levels[j].videoStatus !== false
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 16
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

/*
-----------------------
  Check for PDF's
----------------------
*/
var checkCfa1PDFSubscription = function checkCfa1PDFSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam,
  type
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && selectedLevel === cfaUnlimitedActiveExam)
  ) {
    if (selectedLevel === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (exam_data[i].levels[j].partner) {
              /*
              -------------
                For Partner
              -------------
              */

              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive
              ) {
                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
                  flag = true;
                } else if (
                  exam_data[i].levels[j].noteStatus &&
                  type === 'notes'
                ) {
                  flag = true;
                }
              } else if (
                // #261 — mirror non-partner: pkg 16 is L1's matching-exam unlimited.
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 16
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            } else {
              /*
              -------------
                For App
              -------------
              */
              if (
                exam_data[i].levels[j].package_val === 'expensive' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              } else if (
                exam_data[i].levels[j].package_val === 'simple' &&
                exam_data[i].levels[j].isActive
              ) {
                if (exam_data[i].levels[j].pdfstatus && type === 'question') {
                  flag = true;
                } else if (
                  exam_data[i].levels[j].noteStatus &&
                  type === 'notes'
                ) {
                  flag = true;
                }
              } else if (
                exam_data[i].levels[j].package_val === 'unlimited' &&
                exam_data[i].levels[j].package_id === 16
              ) {
                flag = true;
                break;
              } else if (
                // #261 — pkg 78 (CFA Unlimited+) covers all 3 levels.
                exam_data[i].levels[j].package_val === 'plus' &&
                exam_data[i].levels[j].isActive
              ) {
                flag = true;
                break;
              }
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            (exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 19 ||
              exam_data[i].levels[j].package_id === 39 ||
              exam_data[i].levels[j].package_id === 20)
          ) {
            flag = true;
            break;
          }
        }
      }
    }
    return flag;
  }
};

exports.checkCfa1Subscription = checkCfa1Subscription;
exports.checkCfa1NotesSubscription = checkCfa1NotesSubscription;
exports.checkCfa1VideosSubscription = checkCfa1VideosSubscription;
exports.checkCfa1PDFSubscription = checkCfa1PDFSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/PartnerSubscription/Cfa1Subscription.js